<div class="row" role="main" *ngIf='readOnly'>
  <div class="col-md-12 col-sm-12 table-responsive no-border">
    <form [formGroup]="deviceForm" novalidate>

      <table class="table table-condensed">
        <tbody>
          <tr>
            <td class="col-sm-6 no-left-padding no-right-padding">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th role="columnheader" aria-label="Single Use Device?" class="col-sm-2">
                      Single Use Device?
                    </th>
                    <th role="columnheader" aria-label="Packaged or Labeled as Sterile?"
                      class="col-sm-3">
                      Packaged or Labeled as Sterile?
                    </th>
                    <th role="columnheader" aria-label="Need Sterilization Before Use?"
                      class="col-sm-3">
                      Need Sterilization Before Use?
                    </th>
                    <th role="columnheader" aria-label="Sterilization Method(s)"
                      class="col-sm-4">
                      Sterilization Method(s)
                    </th>
                  </tr>
                  <tr>
                    <td role="gridcell" aria-label="Cell of Single Use Device">
                      <label controlName="singleUseDevice"> </label>
                    </td>
                    <td role="gridcell" aria-label="Cell of Packaged or Labeled as Sterile">
                      <label controlName="packagedOrLabeledAsSterile"></label>
                    </td>
                    <td role="gridcell" aria-label="Cell of Need Sterilization Before Use">
                      <label controlName="needSterilizationBeforeUse"></label>
                    </td>
                    <td class="col-sm-3 no-left-padding no-right-padding">
                      <table class="table table-inner table-condensed"
                        formArrayName="sterilizationMethodsForm">
                        <tbody>

                          <ng-container *ngIf="sterilizationMethodsForm.controls.length; else emptyTemplate1field">
                            <tr formGroupName="{{i}}"
                              *ngFor="let value of sterilizationMethodsForm.controls; let i = index">
                              <td role="gridcell" aria-label="Cell of Sterilization Method(s)">
                                <label controlName="value"></label>
                              </td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <table *ngIf="!sppDevice" class="table table-condensed">
        <tbody>
          <tr>
            <td class="col-sm-12 no-left-padding no-right-padding">
              <table formArrayName="clinicalSizeTypeForm" class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th role="columnheader" aria-label="Clinical Size Type(s)" class="condensed-col-3">
                      Clinical Size Type(s)
                    </th>
                    <th role="columnheader" aria-label="Size Value" class="condensed-col-2">
                      Size Value
                    </th>
                    <th role="columnheader" aria-label="Size Unit" class="condensed-col-2">
                      Size Unit
                    </th>
                    <th role="columnheader" aria-label="Clinical Size Text" class="condensed-col-5">
                      Clinical Size Text
                    </th>
                  </tr>
                  <ng-container *ngIf="clinicalSizeTypeForm?.controls?.length; else emptyTemplate4fields">
                  <tr formGroupName="{{i}}" *ngFor="let sizeGroup of clinicalSizeTypeForm.controls; let i = index">
                    <td role="gridcell" aria-label="Cell of Clinical Size Type(s)">
                      <label controlName="sizeType"></label>
                    </td>
                    <td role="gridcell" aria-label="Cell of Size Value">
                      <label controlName="sizeValue"></label>
                    </td>
                    <td role="gridcell" aria-label="Cell of Size Unit">
                      <label controlName="sizeUnit"></label>
                    </td>
                    <td role="gridcell" aria-label="Cell of Clinical Size Text">
                      <label controlName="clinicalSizeText"></label>
                    </td>
                  </tr>
                  </ng-container>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <table class="table table-condensed">
        <tbody>
          <tr>
            <td class="col-sm-12 no-left-padding no-right-padding">
              <table formArrayName="storageHandlingForm" class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th class="col-sm-4">Storage and Handling Conditions</th>
                    <th class="col-sm-1">Low Value</th>
                    <th class="col-sm-1">High Value</th>
                    <th class="col-sm-1">Unit</th>
                    <th class="col-sm-5"><span class="left-padding-8">Storage and Handling Condition Comment</span></th>
                  </tr>
                  <ng-container *ngIf="storageHandlingForm.controls.length; else emptyTemplate5fields">
                    <tr formGroupName="{{i}}" *ngFor="let storage of storageHandlingForm.controls; let i = index">
                      <td>
                        <label controlName="storageHandlingCondition"></label>
                      </td>
                      <td>
                        <label controlName="valueLow"></label>
                      </td>
                      <td>
                        <label controlName="valueHigh"></label>
                      </td>
                      <td>
                        <label controlName="unit"></label>
                      </td>
                      <td>
                        <table formArrayName="storageHandlingComments" class="table table-inner table-condensed">

                          <ng-container *ngIf="storageHandlingForm.controls.length; else emptyTemplate1field">
                            <tr formGroupName="{{i}}"
                              *ngFor="let comment of storage.get('storageHandlingComments').controls; let i = index">
                              <td class="no-top-padding-inner-table">
                                <label controlName="comments"></label>
                              </td>
                            </tr>
                          </ng-container>
                        </table>
                      </td>
                    </tr>
                  </ng-container>

                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <table class="table table-condensed">
        <tbody>
          <tr>
            <td class="col-sm-12 no-left-padding no-right-padding">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr *ngIf="isAustraliaChannel">
                    <th role="columnheader" aria-label="Kit?" class="col-sm-3">Kit?</th>
                    <th role="columnheader" aria-label="Maximum Number of Reuses" class="col-sm-3">
                      Maximum Number of Reuses
                    </th>
                    <th role="columnheader" aria-label="Is the medical device software or does it incorporate software?"
                      class="col-sm-6">
                      Is the medical device software or does it incorporate software?
                    </th>
                  </tr>
                  <tr *ngIf="isAustraliaChannel">
                    <td role="gridcell" aria-label="Cell of Kit">
                      <label controlName="kit"> </label>
                    </td>
                    <td role="gridcell" aria-label="Cell of Maximum Number of Reuses">
                      <label controlName="maxNumberOfReuse"> </label>
                    </td>
                    <td role="gridcell" aria-label="Cell of Is the medical device software or does it incorporate software?">
                      <label controlName="deviceSoftwareClassification"></label>
                    </td>
                  </tr>
                  <tr *ngIf="!isAustraliaChannel">
                    <th role="columnheader" aria-label="Kit?" class="col-sm-3">Kit?</th>
                    <th role="columnheader" aria-label="Combination Product?" class="col-sm-3">
                      Combination Product?
                    </th>
                    <th role="columnheader" aria-label="Human Cell, Tissue or Cellular or Tissue-Based Product (HCT/P)?"
                      class="col-sm-6">
                      Human Cell, Tissue or Cellular or Tissue-Based Product (HCT/P)?
                    </th>
                  </tr>
                  <tr *ngIf="!isAustraliaChannel">
                    <td role="gridcell" aria-label="Cell of Kit">
                      <label controlName="kit"> </label>
                    </td>
                    <td role="gridcell" aria-label="Cell of Combination Product">
                      <label controlName="combinationProduct"> </label>
                    </td>
                    <td role="gridcell" aria-label="Cell of Human Cell, Tissue or Cellular or Tissue-Based Product (HCT/P)">
                      <label controlName="humanCellTissueProduct"></label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>
</div>
<ng-template #emptyTemplate1field>
  <tr>
    <td><label class="label-padding-bottom-15"></label></td>
  </tr>
</ng-template>
<ng-template #emptyTemplate4fields>
  <tr>
    <td><label></label></td>
    <td><label></label></td>
    <td><label></label></td>
    <td><label></label></td>
  </tr>
</ng-template>
<ng-template #emptyTemplate5fields>
  <tr>
    <td><label></label></td>
    <td><label></label></td>
    <td><label></label></td>
    <td><label></label></td>
    <td><label></label></td>
  </tr>
</ng-template>
